const MAIN = 'MAIN'
const FUNNEL = 'FUNNEL'
const SECONDARY = 'SECONDARY'

export { MAIN, FUNNEL, SECONDARY }
